/**
 * Socket.io namespace path for unauthenticated public portal connections.
 */
export const PUBLIC_REALTIME_NAMESPACE = '/public';
/**
 * Client-to-server socket.io event names used by the public portal realtime connection.
 */
export const PortalRealtimeClientEvent = {
    SUBSCRIBE_GOVERNMENT: 'SUBSCRIBE_GOVERNMENT',
    SUBSCRIBE_MEETING: 'SUBSCRIBE_MEETING',
    UNSUBSCRIBE_MEETING: 'UNSUBSCRIBE_MEETING',
    SUBSCRIBE_LOCATION: 'SUBSCRIBE_LOCATION',
    UNSUBSCRIBE_LOCATION: 'UNSUBSCRIBE_LOCATION',
};
/**
 * Client-to-server socket.io event names used by authenticated (private) realtime connections.
 */
export const RealtimeClientEvent = {
    SUBSCRIBE_MEETING: 'SUBSCRIBE_MEETING',
    UNSUBSCRIBE_MEETING: 'UNSUBSCRIBE_MEETING',
};
/**
 * Realtime service event types for use across the application.
 * Shared between the realtime-service worker and frontend clients.
 */
export const RealtimeServiceEventType = {
    AGENDA_CHANGE: 'AGENDA_CHANGE',
    DOCUMENT_CHECKOUTS_CHANGE: 'DOCUMENT_CHECKOUTS_CHANGE',
    LEGISLATIVE_ITEM_CHANGE: 'LEGISLATIVE_ITEM_CHANGE',
    LEGISLATIVE_ITEM_COMMENTS_CHANGE: 'LEGISLATIVE_ITEM_COMMENTS_CHANGE',
    MEETING_DOCUMENTS_CHANGE: 'MEETING_DOCUMENTS_CHANGE',
    MEETING_EVENT_CHANGE: 'MEETING_EVENT_CHANGE',
    MEETING_ROLL_CALLS_CHANGE: 'MEETING_ROLL_CALLS_CHANGE',
    MEETING_SPEAKERS_CHANGE: 'MEETING_SPEAKERS_CHANGE',
    MEETING_STREAMING_CHANGE: 'MEETING_STREAMING_CHANGE',
    MEETING_TIMESTAMPS_CHANGE: 'MEETING_TIMESTAMPS_CHANGE',
    MEETING_TRANSCRIPTS_CHANGE: 'MEETING_TRANSCRIPTS_CHANGE',
    MEMBER_VOTE: 'MEMBER_VOTE',
    MINUTES_ENTRIES_CHANGE: 'MINUTES_ENTRIES_CHANGE',
    MINUTES_ENTRY_CHANGE: 'MINUTES_ENTRY_CHANGE',
    NOTIFICATIONS_CHANGE: 'NOTIFICATIONS_CHANGE',
    PUBLIC_AGENDA_CHANGE: 'PUBLIC_AGENDA_CHANGE',
    PUBLIC_MEETING_DOCUMENTS_CHANGE: 'PUBLIC_MEETING_DOCUMENTS_CHANGE',
    PUBLIC_MEETING_EVENT_CHANGE: 'PUBLIC_MEETING_EVENT_CHANGE',
    PUBLIC_MEETING_STREAMING_CHANGE: 'PUBLIC_MEETING_STREAMING_CHANGE',
    PUBLIC_MINUTES_ENTRIES_CHANGE: 'PUBLIC_MINUTES_ENTRIES_CHANGE',
    PUBLIC_MINUTES_ENTRY_CHANGE: 'PUBLIC_MINUTES_ENTRY_CHANGE',
    PUBLIC_LOCATION_CHANGE: 'PUBLIC_LOCATION_CHANGE',
};
